import React from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'

import {
  SEO,
  Logo,
  StateSwitcher,
  SiteSwitcher,
  Search,
} from '../../components'

import './style.scss'

const Header = props => (
  <header className={'header ' + props.site}>
    <SEO title={props.title} />
    <Link to="/">
      <Logo site={props.site} />
    </Link>
    <SiteSwitcher
      slug={props.slug}
      site={props.site}
      exclusive={props.exclusive}
    />
    <Search site={props.site} state={props.state} />
    <StateSwitcher site={props.site} state={props.state} slug={props.slug} />
  </header>
)

Header.propTypes = {
  site: PropTypes.string,
  title: PropTypes.string,
  slug: PropTypes.string,
  state: PropTypes.string,
}

export default Header
